var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appPagination"},[_c('el-pagination',{attrs:{"page-sizes":_vm.pageSizesArr,"total":_vm.total,"current-page":_vm.currentPage,"page-size":_vm.pageSize,"layout":_vm.layout,"background":_vm.background,"small":true},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }